<script lang="ts">
  import type { DropdownPoints } from './dropdown.types';
  import DropdownPoint from './DropdownPoint.svelte';

  const { points }: { points: DropdownPoints } = $props();
</script>

{#each Object.entries(points) as [id, point] (id)}
  <DropdownPoint icon={point.icon} href={point.href} active={point.active} separated={point.separated} onselect={point.onselect}>
    {point.label}
  </DropdownPoint>
{/each}
